<div class="d-flex flex-column justify-content-center align-items-center w-100" [formGroup]="form">
  <div class="app-labels d-flex justify-content-between w-100">
    <div class="app-label app-min-label">
      {{ label[0] }}
    </div>
    <div class="app-label app-max-label">
      {{ label[1] }}
    </div>
  </div>
  <div [formGroupName]="controlName + '_Group'" class="w-100">
    <input
      type="range"
      class="form-control-range"
      name="slider"
      id="slider"
      [min]="range[0]"
      [max]="range[1]"
      [formControlName]="controlName"
      (change)="onChange($event)"
      (click)="onClick($event)"
      step="1"
      />
  </div>
  @if (getFormGroup().controls[controlName].invalid) {
    <div class="alert alert-danger mt-3">
      {{ warning }}
    </div>
  }
</div>
